module.exports = __webpack_public_path__ + "static/media/7.question.36182952.mp4";